<template>
  <div class="mt-1">
    <div
      class="color-field color-circle pointer"
      :id="'color-' + uuid"
      tabindex="0"
      @keyup.enter="$refs.popover.open()"
      :style="{ backgroundColor: toHex(value) }"
    ></div>
    <popover :target="'color-' + uuid" ref="popover">
      <ul class="list-unstyled colors-list d-flex mb-0">
        <li
          class="color-circle option pointer"
          :class="{ selected: color === value }"
          v-for="color in colorPalette"
          :style="{ backgroundColor: toHex(color) }"
          :key="color"
          @click="onSelection(color)"
        ></li>
      </ul>
      <hr v-if="allowReset" />
      <div class="flex-center mt-n2" v-if="allowReset">
        <link-button class="p-0 text-medium" @click="onSelection(NO_COLOR)">
          Reset
        </link-button>
      </div>
    </popover>
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton'
import Popover from '@/components/Popover'
import { NO_COLOR, COLORS } from '@/constants/common'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import getHexColorValueFromCode from '@/utils/initiative/getHexColorValueFromCode'

// TODO: enable KB navigation on colors
/**
 * This component lets users pick color for Dropdown CF options
 */
export default {
  name: 'ColorPicker',
  props: ['value', 'allowReset', 'palette'],
  mixins: [ComponentIdMixin],
  components: {
    Popover,
    LinkButton
  },
  data() {
    return {
      colorPalette: this.palette || COLORS,
      NO_COLOR
    }
  },
  computed: {},
  methods: {
    toHex: getHexColorValueFromCode,
    onSelection(color) {
      this.$emit('input', color)
      this.$refs.popover.close()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.color-circle {
  border-radius: 50%;
}
.option {
  @include dimension(25px, 25px);

  transition: transform ease-in 100ms;

  &:hover {
    transform: scale(1.2);
  }
}
.color-field {
  @include dimension(28px, 28px);
  border: 1px solid $borderPrimary;
}
.colors-list {
  gap: 12px;
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr;
}

.selected {
  border: 1px solid $secondary;
}
</style>
